import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import {
  Table,
  IconButton,
  Icon,
  Panel,
  ButtonGroup,
  Row,
  Col,
  Dropdown,
  SelectPicker,
  Input,
  Button,
  DatePicker,
  CheckPicker,
} from 'rsuite'
import { useHistory } from 'react-router-dom'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { DATE_FORMAT } from '../../constants/date'
import moment from 'moment'
import { budgetFormat } from '../../utils/formatterUtil'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import {
  downloadSubprojectAll,
  getSubprojectAll,
  searchSubprojectAll,
} from '../../redux/actions/SearchSubproject'
import { doneLoading, startLoading } from '../../utils/loading'
import { downloadFile } from '../../utils/fileUtil'
import notification from '../../utils/notification'
import pathname from '../../constants/pathname'

export default function SearchSubprojectTable({ schema, ...props }) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const { Column, HeaderCell, Cell } = Table
  const history = useHistory()
  const [tableData, setTableData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)

  const [txtSubProjectCodeVal, setTxtsubProjectCodeVal] = useState('')
  const [txtProjectNameVal, setTxtProjectNameVal] = useState('')
  const [txtGranteeSubProjectCodeVal, setTxtGranteeSubProjectCodeVal] = useState('')
  const [txtLeaderManageNameVal, setTxtLeaderManageNameVal] = useState('')
  const [txtOperatingAreaVal, setTxtOperatingAreaVal] = useState(0)
  const [txtRegionVal, setTxtRegionVal] = useState(0)
  const [txtContractNoVal, setTxtcontractNoVal] = useState('')
  const [txtCoordinatorSuportorNameVal, setTxtcoordinatorSuportorNameVal] = useState('')

  const _defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
    { value: 20, label: 20 },
  ]

  const [page, setPage] = useState(1)
  const [displayLength, setDisplayLength] = useState(5)
  const [defaultLengthMenu, setDefaultLengthMenu] = useState(_defaultLengthMenu)
  const [totalSize, setTotalSize] = useState(schema.data.totalSize || 0)

  // const page = 1
  // const displayLength = 5

  useEffect(() => {
    console.log('schema?.data?.values => ', schema.data.totalSize)

    setTableData(schema?.data?.values || [])
    setTotalSize(schema.data.totalSize)
  }, [schema])

  const onExport = async () => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const request = {
        projectCode: txtSubProjectCodeVal || null,
        projectName: txtProjectNameVal || null,
        grentee: txtGranteeSubProjectCodeVal || null,
        leader: txtLeaderManageNameVal || null,
        contractNo: txtContractNoVal || null,
        evaluationTeam: txtCoordinatorSuportorNameVal || null,
        area: txtOperatingAreaVal.length ? txtOperatingAreaVal.toString() : null,
        region: txtRegionVal.length ? txtRegionVal.toString() : null,
      }

      const file = await downloadSubprojectAll(request)
      console.log('response', file)

      if (file) {
        downloadFile(file, file.name || `รายงานข้อมูลโครงการย่อย`)
      } else {
        notification.open('error', {
          title: 'ดาวน์โหลดเอกสารไม่สำเร็จ',
        })
      }
    } catch (e) {
      setIsError(true)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || 'ไม่สามารถแสดงข้อมูลได้',
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleSearch = async () => {
    console.log('handleSearch')
    const res = await callSearchReport()

    // console.log('resssss => ', res.form.data)
    if (res) {
      setTableData(res?.form?.data?.values || [])
      setPage(1)
      setDisplayLength(5)
    }
  }

  const handleCancel = async () => {
    console.log('handleCancel ')

    setTxtsubProjectCodeVal('')
    setTxtProjectNameVal('')
    setTxtGranteeSubProjectCodeVal('')
    setTxtLeaderManageNameVal('')
    setTxtcontractNoVal('')
    setTxtcoordinatorSuportorNameVal('')
    setTxtOperatingAreaVal('')
    setTxtRegionVal('')
    // setPage(1)
    // setDisplayLength(5)
    // setTotalSize(schema.data.totalSize)

    // await callSearchReport()
    const response = await getSubprojectAll(5, 1)
    console.log('response=> ', response?.form?.data?.totalSize)
    if (response) {
      setTotalSize(response?.form?.data?.totalSize || schema?.data?.totalSize || 0)
      setTableData(response?.form?.data?.values || [])
    }
  }

  const callSearchReport = async (pageSize = 5, pageNumber = 1) => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      // console.log('txtOperatingAreaVal => ', txtOperatingAreaVal)

      const request = {
        projectCode: txtSubProjectCodeVal || null,
        projectName: txtProjectNameVal || null,
        grentee: txtGranteeSubProjectCodeVal || null,
        leader: txtLeaderManageNameVal || null,
        contractNo: txtContractNoVal || null,
        AcademicSupportTeam: txtCoordinatorSuportorNameVal || null,
        area: txtOperatingAreaVal.length ? txtOperatingAreaVal.toString() : null,
        region: txtRegionVal.length ? txtRegionVal.toString() : null,
      }

      const response = await searchSubprojectAll(pageSize, pageNumber, request)
      if (response) {
        setTotalSize(response?.form?.data?.totalSize || schema?.data?.totalSize || 0)
      }
      setIsLoading(false)
      doneLoading()

      return response
    } catch (e) {
      setIsError(true)
      console.log('error => ', e)
    }

    setIsLoading(false)
    doneLoading()
  }

  const handleChangePage = async (dataKey) => {
    console.log('dataKey => ', dataKey)
    const res = await callSearchReport(displayLength, dataKey)

    if (res) {
      setTableData(res?.form?.data?.values || [])
      setPage(dataKey)
      setDisplayLength(displayLength)
    }
  }

  const handleChangeLength = async (dataKey) => {
    console.log('handleChangeLength => ', dataKey)
    const res = await callSearchReport(dataKey, 1)

    if (res) {
      setTableData(res?.form?.data?.values || [])
      setPage(1)
      setDisplayLength(dataKey)
    }
  }

  const onSelect = (data) => {
    console.log('onSelect => ', data)

    sessionStorage.setItem('projectId', data.projectversionId)
    sessionStorage.setItem('sub_projectId', data.projectversionId)
    sessionStorage.setItem('param', '')

    history.push(`${pathname.subProject.overviewSubProject}`)
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      {schema?.searchForm && (
        <Panel bordered header={'ค้นหา'} collapsible defaultExpanded>
          <div style={{ marginTop: -10, marginBottom: -10 }}>
            <Row style={{ marginBottom: 10 }}>
              <Col lg={4} md={4} sm={24} xs={24}></Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                {schema.searchForm.subProjectCode.label}
                <Input
                  value={txtSubProjectCodeVal}
                  onChange={(value) => {
                    setTxtsubProjectCodeVal(value)
                  }}
                />
              </Col>

              <Col lg={8} md={8} sm={24} xs={24}>
                {schema.searchForm.projectName.label}
                <Input
                  value={txtProjectNameVal}
                  onChange={(value) => {
                    setTxtProjectNameVal(value)
                  }}
                />
              </Col>
              <Col lg={4} md={4} sm={24} xs={24}></Col>
            </Row>
            <Row style={{ marginBottom: 10 }}>
              <Col lg={4} md={4} sm={24} xs={24}></Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                {schema.searchForm.granteeSubProjectCode.label}
                <Input
                  value={txtGranteeSubProjectCodeVal}
                  onChange={(value) => {
                    setTxtGranteeSubProjectCodeVal(value)
                  }}
                />
              </Col>

              <Col lg={8} md={8} sm={24} xs={24}>
                {schema.searchForm.leaderManageName.label}
                <Input
                  value={txtLeaderManageNameVal}
                  onChange={(value) => {
                    setTxtLeaderManageNameVal(value)
                  }}
                />
              </Col>
              <Col lg={4} md={4} sm={24} xs={24}></Col>
            </Row>
            <Row style={{ marginBottom: 10 }}>
              <Col lg={4} md={4} sm={24} xs={24}></Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                {schema.searchForm.contractNo.label}
                <Input
                  value={txtContractNoVal}
                  onChange={(value) => {
                    setTxtcontractNoVal(value)
                  }}
                />
              </Col>

              <Col lg={8} md={8} sm={24} xs={24}>
                {schema.searchForm.coordinatorSuportorName.label}
                <Input
                  value={txtCoordinatorSuportorNameVal}
                  onChange={(value) => {
                    setTxtcoordinatorSuportorNameVal(value)
                  }}
                />
              </Col>
              <Col lg={4} md={4} sm={24} xs={24}></Col>
            </Row>
            <Row style={{ marginBottom: 10 }}>
              <Col lg={4} md={4} sm={24} xs={24}></Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                {schema.searchForm.operatingArea.label}
                <CheckPicker
                  sticky
                  data={schema.searchForm.operatingArea.options}
                  value={txtOperatingAreaVal}
                  block
                  placeholder="เลือก"
                  onChange={(value) => {
                    console.log('value => ', value)
                    setTxtOperatingAreaVal(value)
                  }}
                />
              </Col>

              <Col lg={8} md={8} sm={24} xs={24}>
                {schema.searchForm.region.label}
                <CheckPicker
                  sticky
                  data={schema.searchForm.region.options}
                  value={txtRegionVal}
                  block
                  placeholder="เลือก"
                  onChange={(value) => {
                    // console.log('x => ', value)
                    setTxtRegionVal(value)
                  }}
                />
              </Col>
              <Col lg={4} md={4} sm={24} xs={24}></Col>
            </Row>

            <Row style={{ marginBottom: 10 }}>
              <Col lg={4} md={4} sm={24} xs={24}></Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                <SearchButton disabled={false} onClick={handleSearch}>
                  ค้นหา
                </SearchButton>
                {`  `}
                <CancelButton disabled={false} onClick={handleCancel}>
                  ยกเลิก
                </CancelButton>
              </Col>
            </Row>
          </div>
        </Panel>
      )}
      <Row style={{ marginTop: 10 }}>
        <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
          <IconButton
            appearance="ghost"
            icon={<Icon icon="file-pdf-o" className="bt-gost-icon-radius" />}
            onClick={onExport}
          >
            Export to MS-Excel
          </IconButton>
        </Col>
      </Row>

      <Table
        wordWrap
        minHeight={400}
        autoHeight
        loading={isLoading}
        data={tableData}
        style={{ marginTop: 10 }}
      >
        <Column width={90} align="center">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return (page - 1) * displayLength + index + 1
            }}
          </Cell>
        </Column>

        <Column width={150}>
          <HeaderCell>รหัสโครงการย่อย </HeaderCell>
          <Cell dataKey="projectCode" />
        </Column>
        <Column width={150}>
          <HeaderCell>เลขที่ข้อตกลง</HeaderCell>
          <Cell dataKey="contractNo" />
        </Column>
        <Column width={280}>
          <HeaderCell>ชื่อโครงการย่อย</HeaderCell>
          <Cell dataKey="projectName" />
        </Column>

        <Column width={200}>
          <HeaderCell>ผู้รับทุนโครงการย่อย </HeaderCell>
          <Cell dataKey="granteeName" />
        </Column>

        <Column width={200}>
          <HeaderCell>ผู้รับผิดชอบโครงการย่อย </HeaderCell>
          <Cell dataKey="responsinatorName" />
        </Column>

        <Column width={220}>
          <HeaderCell>วันเริ่มต้น-สิ้นสุดโครงการย่อย</HeaderCell>
          <Cell dataKey="projectStartAndEnd" />
        </Column>

        <Column width={150} align="right">
          <HeaderCell>งบประมาณ</HeaderCell>
          <Cell>
            {(rowData) => {
              return budgetFormat(rowData.totalBudget || 0)
            }}
          </Cell>
        </Column>

        <Column width={200}>
          <HeaderCell>ทีมสนับสนุนวิชาการ</HeaderCell>
          <Cell dataKey="academicSupportTeam" />
        </Column>
        <Column width={200}>
          <HeaderCell>หัวหน้าหน่วยจัดการ</HeaderCell>
          <Cell dataKey="leaderManageName" />
        </Column>
        <Column width={200}>
          <HeaderCell>ทีมประเมินผล </HeaderCell>
          <Cell dataKey="evaluationTeam" />
        </Column>
        <Column width={200}>
          <HeaderCell>นักวิชาการ สสส. </HeaderCell>
          <Cell dataKey="coordinatorName" />
        </Column>

        <Column width={120} align="center" fixed="right">
          <HeaderCell>คลิก</HeaderCell>
          <Cell>
            {(rowData) => {
              return (
                <>
                  <ButtonGroup>
                    <ViewButton
                      icon="eye"
                      onClick={() => {
                        onSelect(rowData)
                      }}
                    >
                      แสดง
                    </ViewButton>
                  </ButtonGroup>
                </>
              )
            }}
          </Cell>
        </Column>
      </Table>

      <TablePagination
        lengthMenu={defaultLengthMenu}
        activePage={page}
        renderLengthMenu={(lengthMenu) => {
          return (
            <>
              {lengthMenu}
              {`รายการ/หน้า`}
            </>
          )
        }}
        renderTotal={(total) => {
          return <>{` ทั้งหมด ${total} รายการ`}</>
        }}
        displayLength={displayLength || 5}
        total={totalSize}
        onChangePage={handleChangePage}
        onChangeLength={handleChangeLength}
      />
    </>
  )
}
